export const productName = 'MEGAPACK MINERÍA LISTO';
export const productShortName = 'Megapack Minería Listo';
export const productImage = 'https://cdn.magicpatterns.com/uploads/dLxxrnhneHnPskozutidTb/MOCKUP.png';

export const checkoutUrl = 'https://megapack-mineria-listo.impultienda.ar/checkout';

export const price = 'USD 19,00';
export const priceBefore = 'USD 40,00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70,00';

export const included = [
  'Tomo 1 — Fundamentos de Minería y Recursos Minerales',
  'Tomo 2 — Geología Aplicada a la Minería',
  'Tomo 3 — Exploración y Evaluación de Recursos Minerales',
  'Tomo 4 — Métodos de Explotación Minera',
  'Tomo 5 — Procesamiento y Beneficio de Minerales',
  'Tomo 6 — Seguridad, Higiene y Gestión de Riesgos en Minería',
  'Tomo 7 — Gestión Ambiental y Sostenibilidad Minera',
  'Tomo 8 — Minería, Sociedad y Comunidades',
  'Tomo 9 — Enseñanza de la Minería: Estrategias, Actividades y Proyectos Educativos',
  'Bono 1 — 150 Actividades y Desafíos',
  'Bono 2 — Kit de Evaluación Completo',
  'Bono 3 — 100 Casos y Situaciones Problemáticas',
  'Bono 4 — Diccionario Docente de 200 Conceptos',
  'Bono 5 — 50 Proyectos Educativos',
  'Garantía de 7 días sin preguntas',
  'Acceso inmediato',
];

export const systemNegatives = [
  'No es teoría copiada de un manual desactualizado.',
  'No es una colección de actividades sueltas sin coherencia.',
  'No es material que tengas que adaptar entero.',
];

export const closingLines = [
  'Sin más noches buscando cómo explicar conceptos de minería complejos',
  'Sin más clases armadas de apuro con material que no funciona',
  'Sin más alumnos desconectados que no entienden para qué sirve la minería',
  'Sin más fines de semana perdidos construyendo material desde cero',
  'Sin más silencios incómodos frente a preguntas técnicas que te ponen en aprietos',
];
